export const CONTRACT_TYPES = {
  CollectingSocietyContract: `Collecting society`,
  RightsholderContract: `Rightsholder`,
  // DistributingPublisherContract: `Distributing publisher`,
  // ProducerContract: `Producer`,
}
